module.exports = __webpack_public_path__ + "static/media/api-deploiement.a2268ba5.png";